import { FETCH_MONITORED_DOCUMENT_VERSIONS } from '../actions/MonitoredDocumentActions';

// INITIALIZE STATE
const initialState = {
    monitoredDocumentVersions: null,
    fetching: false,
    fetched: false,
    failed: false,
    paging: {
        total: 0,
        pageNumber: 1,
        pageSize: 5,
        pages: 1,
    },
};

// REDUCER
export const MonitoredDocumentVersionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_MONITORED_DOCUMENT_VERSIONS}_PENDING`:
            return {
                ...state,
                monitoredDocumentVersions: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT_VERSIONS}_FULFILLED`:
            return {
                ...state,
                monitoredDocumentVersions: action.payload.data,
                paging: action.payload.paging,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT_VERSIONS}_REJECTED`:
            return {
                ...state,
                monitoredDocumentVersions: null,
                fetching: false,
                fetched: false,
                failed: true,
            };
        default:
            return state;
    }
};
